import { IonButton } from '@ionic/react';
import React, { forwardRef } from 'react';

import './Button.scss';
import { ButtonProps } from './types';

const Button = forwardRef<HTMLIonButtonElement, ButtonProps>(
  (
    {
      children,
      type = 'button',
      onClick,
      color = 'primary',
      fill = 'solid',
      size,
      disabled = false,
      marginBottom = true,
      noMarginTop = false,
    },
    ref,
  ) => {
    return (
      <div
        className={[
          'button',
          marginBottom && 'button--mb',
          noMarginTop && 'button--no-mt',
          size === 'small' && 'button--small',
          fill === 'outline' && 'button--outline',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <IonButton
          ref={ref}
          type={type}
          onClick={onClick}
          mode="ios"
          expand="block"
          color={color}
          fill={fill}
          disabled={disabled}
          className="no-disabled-opacity"
        >
          {children}
        </IonButton>
      </div>
    );
  },
);

export default React.memo(Button);